import { useCallback } from "react";
import { translate } from "app/filters/i18nFilter";
import {
    MANAGEMENT_COMMON_DAYS,
    MANAGEMENT_COMMON_HOURS,
    MANAGEMENT_COMMON_MINUTES,
} from "../../../../translations/managementKeys";
import { salesforceFormatDate } from "../../../../../../modules/manage-integrations/utils/salesforceFormatDate";
import { StyledTimeContainer } from "../../../Management/styles";

export const IntegrationSyncTime = ({ text, time }: { text?: string; time?: string }) => {
    const getSyncedTime = useCallback(() => {
        if (!text || !time) {
            return "";
        }

        return salesforceFormatDate(
            `${time}Z`,
            translate(MANAGEMENT_COMMON_MINUTES),
            translate(MANAGEMENT_COMMON_HOURS),
            translate(MANAGEMENT_COMMON_DAYS),
        );
    }, [text, time]);

    return <StyledTimeContainer>{`${text}: ${getSyncedTime()}`}</StyledTimeContainer>;
};
